import { useLocation } from 'react-router-dom';

export default function Header() {
  const location = useLocation();
  const DONATE_URL = 'https://e001e9ac-68a7-4c40-b8ea-95640b3298a4.paylinks.godaddy.com/5d21dd81-b1d5-4b22-8cd2-c45';

  return (
    <header className="bg-white shadow-sm border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <a href="/" className="flex items-center space-x-2">
            <div className="w-8 h-8 bg-orange-500 rounded-full flex items-center justify-center">
              <i className="ri-heart-fill text-white w-5 h-5 flex items-center justify-center"></i>
            </div>
            <span className="text-2xl font-bold text-gray-900" style={{ fontFamily: '"Inter", sans-serif' }}>
              El Dorado Cat Rescue
            </span>
          </a>

          <div className="hidden md:flex space-x-8">
            <a href="/" className="text-gray-700 hover:text-orange-500 transition-colors cursor-pointer">
              Home
            </a>
            <a href="/adoption" className="text-gray-700 hover:text-orange-500 transition-colors cursor-pointer">
              Adopt
            </a>
            <a href="/blog" className="text-gray-700 hover:text-orange-500 transition-colors cursor-pointer">
              Blog
            </a>
            <a
              href={DONATE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-700 hover:text-orange-500 transition-colors cursor-pointer"
            >
              Donate
            </a>
            <a href="/contact" className="text-gray-700 hover:text-orange-500 transition-colors cursor-pointer">
              Contact
            </a>
          </div>
        </div>
      </div>
    </header>
  );
}